import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HttpService } from '../../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root',
})
export class ImportarArquivoFuncionarioService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  saveEmployeeImport(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/notification/sendNotification/email', data, successHandle, errorHandle);
  }
  buscaSaldoGlobal(data: any, successHandle: Function, errorHandle: Function) {
    this.httpService.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);
  }
 
  buscarSaldoRecebiveis(data: any, successHandle: Function, errorHandle: Function) {
    this.httpService.doGet('/enterprise/returnRetailReceivablesBalance', data, successHandle, errorHandle);
  }
 

}
